import React, { useEffect, useState } from "react";
import { Box, createStyles, Grid, Hidden, makeStyles, Theme } from "@material-ui/core";
import AccountInfo from "./AccountInfo";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { RouteComponentProps } from "react-router";
import { MAIN } from "../../Routing/routes";
import ChangePassForm from "./ChangePassForm";
import ButtonNav from "../../shared/NavBar/ButtonNav";
import AdditionalInfo from "./AdditionalInfo";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: "2%",
      marginBottom: "100px",
    },
  })
);

const MyAccount: React.FC<RouteComponentProps> = ({ history }) => {
  const classes = useStyles();
  const isLoggingIn = useSelector((state: State) => state.auth.isLoggedIn);
  const [openChangePass, setOpenChangePass] = useState(false);

  useEffect(() => {
    if (!isLoggingIn) {
      history.push(MAIN);
    }
  }, [isLoggingIn]);

  return (
    <React.Fragment>
      <Grid container className={classes.container}>
        <Hidden mdDown>
          <Grid item xs={4}>
            <h3>Moje dane: </h3>
            <AccountInfo />
            <Box my={3} style={{ width: "100%" }}>
              <ButtonNav onClick={() => setOpenChangePass(true)}>Zmień hasło</ButtonNav>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <AdditionalInfo />
          </Grid>
        </Hidden>
        <Hidden lgUp>
          <Grid item xs={12}>
            <h3>Moje dane: </h3>
            <AccountInfo />
            <Box my={3} style={{ width: "100%" }}>
              <ButtonNav onClick={() => setOpenChangePass(true)}>Zmień hasło</ButtonNav>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <AdditionalInfo />
          </Grid>
        </Hidden>
      </Grid>
      <ChangePassForm open={openChangePass} onClose={() => setOpenChangePass(false)} />
    </React.Fragment>
  );
};

export default MyAccount;
